function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { ContextProvider as t } from "../controllers/context-provider.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

function e(_ref) {
  var e = _ref.context;
  return function (n, i) {
    var o = new WeakMap();
    if ("object" == _typeof(i)) return i.addInitializer(function () {
      o.set(this, new t(this, {
        context: e
      }));
    }), {
      get: function get() {
        return n.get.call(this);
      },
      set: function set(t) {
        var _o$get;

        return (_o$get = o.get(this)) !== null && _o$get !== void 0 && _o$get.setValue(t), n.set.call(this, t);
      },
      init: function init(t) {
        var _o$get2;

        return (_o$get2 = o.get(this)) !== null && _o$get2 !== void 0 && _o$get2.setValue(t), t;
      }
    };
    {
      n.constructor.addInitializer(function (n) {
        o.set(n, new t(n, {
          context: e
        }));
      });
      var r = Object.getOwnPropertyDescriptor(n, i);
      var s;

      if (void 0 === r) {
        var _t = new WeakMap();

        s = {
          get: function get() {
            return _t.get(this);
          },
          set: function set(e) {
            o.get(this).setValue(e), _t.set(this, e);
          },
          configurable: !0,
          enumerable: !0
        };
      } else {
        var _t2 = r.set;
        s = _objectSpread(_objectSpread({}, r), {}, {
          set: function set(e) {
            o.get(this).setValue(e), _t2 === null || _t2 === void 0 ? void 0 : _t2.call(this, e);
          }
        });
      }

      return void Object.defineProperty(n, i, s);
    }
  };
}

export { e as provide };